export const MAX_BROWSER_TIMER_DELAY_MS = 2_147_483_647;

export function getNextExpiryDelay(expiresAt: number, now = Date.now()): number {
  return Math.min(Math.max(0, expiresAt - now), MAX_BROWSER_TIMER_DELAY_MS);
}
